const isDevelopment = process.env.NODE_ENV === 'development';
const DEFAULT_PRODUCTION_ORIGIN = "https://www.bodex.se";

const isBodexNoHost = () => {
   if (typeof window === 'undefined') return false;
   const hostname = (window.location.hostname || '').toLowerCase();
   return (
      hostname === 'bodex.no'
      || hostname.endsWith('.bodex.no')
      || hostname === 'bodex.dk'
      || hostname.endsWith('.bodex.dk')
   );
};

const getProductionOrigin = () => {
   if (isBodexNoHost()) {
      return window.location.origin;
   }

   return DEFAULT_PRODUCTION_ORIGIN;
};

// Get mapbox token based on environment
const getMapboxToken = () => {
   if (isDevelopment) {
      return process.env.REACT_APP_MAPBOX_TOKEN_DEV;
   } else {
      return process.env.REACT_APP_MAPBOX_TOKEN_PROD;
   }
};

const config = {
   backend_url: isDevelopment ? "https://localhost:5001" : getProductionOrigin(),
   frontend_url: isDevelopment ? "https://localhost:3000" : getProductionOrigin(),
   mapbox_token: getMapboxToken()
};

export default config;
  

/* production:
const config = {
backend_url: "https://192.168.50.21:5000/",
frontend_url: "https://192.168.50.21:3000/",    
backend_url: "http://83.209.216.136:5000/", 
backend_url: "http://localhost:5000/", om testa med produktions server waitress

const config = {
    backend_url: "http://localhost:5000/",
    frontend_url: "https://83.209.216.25/",
    mapbox_token: "pk.eyJ1Ijoid2VsZmFyZXJlbGF4IiwiYSI6ImNtN2dmZjVmazByNjEyaXM3cXB5cnB4ZDkifQ.KUkxMP7igULqjNxjeXBoqQ"
 };

 const config = {
    backend_url: "https://83.209.216.25",
    frontend_url: "https://83.209.216.25/",
    mapbox_token: "pk.eyJ1Ijoid2VsZmFyZXJlbGF4IiwiYSI6ImNtN2dmZjVmazByNjEyaXM3cXB5cnB4ZDkifQ.KUkxMP7igULqjNxjeXBoqQ"
 }; served with backend on 83.209.216.25:5000

 }; */
